import { useInventoryId } from '@/hooks/use-inventory-id';
import { useGetInventoryMeQuery } from '@/api/inventories';
import { isNil } from 'lodash/fp';

const useIsEditor = () => {
  const inventoryId = useInventoryId();
  const { data: inventoryMe } = useGetInventoryMeQuery(inventoryId, {
    skip: isNil(inventoryId),
  });
  return Boolean(inventoryMe?.access?.isEditor);
};

export { useIsEditor };
